export const SupportEmail = 'retro@tsf.tech';
export const AuthTimeout = 2000;
